import { useHistory } from "react-router-dom";
import { linkedRecordTypeDefinitions } from "../domain/linkedRecordTypeDefinitions";
import { LinkedRecordViewModel } from "../domain/LinkedRecordViewModel";

const TAB_PREFERENCE_KEY_NAME = "tabPreference";
const TAB_PREFERENCE_KEY_VALUE = "linkedRecords";

export const useNavigate = (viewModel: LinkedRecordViewModel) => {
  const history = useHistory();
  return () => {
    const definition = linkedRecordTypeDefinitions.find(
      (def) => def.type === viewModel.linkedEntityType
    );
    if (definition) {
      history.push(
        `${definition.navigatePathRoot}${viewModel.linkedEntityId}`,
        {
          [TAB_PREFERENCE_KEY_NAME]: TAB_PREFERENCE_KEY_VALUE,
        }
      );
    }
  };
};
